import {Component, Input, OnInit} from '@angular/core';
import {orderBy} from 'lodash';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';
import {DictionaryObject} from '../../../../../../../../../common/api';
import {FileUtils} from '../../../../../../../../../common/utils';
import {AttachmentItem, CorporateProfileAttachments} from '../../../../api/entity';
import {AttachmentTypeService, CorporateAccountsService, FileDownloadService} from '../../../../api/service';
import {AttachmentType, AttachmentTypeID} from '../../../../../../../shared/api/entity/attachment';
import {finalize} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';


@Component({
    selector: 'tfl-corporate-profile-documents',
    template: require('./corporate-profile.documents.component.html')
})
export class CorporateProfileDocumentsComponent implements OnInit {

    @Input('profile-id') profileId: number;
    @Input('profile-name') profileName: string;

    loading = true;
    hasData = false;

    attachmentSubTypes: DictionaryObject[] = [];
    authSignatoryAttachments: AttachmentItem[] = [];
    profileDocuments: CorporateProfileAttachments;

    constructor(private _corporateAccountService: CorporateAccountsService,
                private _fileDownloadService: FileDownloadService,
                private _attachmentTypeService: AttachmentTypeService) {
    }

    ngOnInit() {
        this.loadAttachmentsSubTypes().subscribe(() => this.loadAttachments());
    }

    saveArchive() {
        const fileName = `profile-${this.profileId}`;
        this._fileDownloadService.downloadAllCorporateAttachmentsFile(this.profileId, fileName)
            .subscribe(response => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            });
    }

    onDownloadFile(fileId) {
        this._fileDownloadService.downloadFile(fileId)
            .subscribe(response => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            });
    }

    private loadAttachmentsSubTypes(): Observable<DictionaryObject[][]> {
        return Observable.forkJoin(Array.from(Object.keys(AttachmentType)).map(type =>
            this._attachmentTypeService.getAttachmentSubTypes(type as AttachmentType).map((subTypes => {
                subTypes.forEach(subType => this.attachmentSubTypes.push(subType));
                return subTypes;
            }))));
    }

    private loadAttachments() {
        this._corporateAccountService.getCorporateProfileAttachments(this.profileId)
            .pipe(
                finalize(() => this.loading = false)
            )
            .subscribe(res => {
                if (!isNullOrUndefined(res)) {
                    this.profileDocuments = res;
                    this.groupProfileAttachments();
                    this.hasData = true;
                }
            });
    }

    private groupProfileAttachments() {
        this.profileDocuments.attachments
            .forEach(attachment => {
                switch (attachment.attachmentTypeId) {
                    case AttachmentTypeID.PASSPORT:
                    case AttachmentTypeID.SELFIE:
                    case AttachmentTypeID.ADDRESS:
                        this.authSignatoryAttachments.push(attachment);
                        break;
                }
            });
        this.authSignatoryAttachments = orderBy(this.authSignatoryAttachments, ['attachmentSubTypeId']);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile-details/documents/corporate/corporate-profile.documents.component.ts